import React from "react";
import { Reveal, Overline, Stagger, StaggerItem } from "./Reveal";
import { IMAGES } from "../lib/content";

const BLOCKS = [
  { title: "Who We Are", body: "KRV Nexus is a multi-business organization building consumer and knowledge-driven ventures." },
  { title: "What We Build", body: "Retail, financial education, market research, technology-enabled business models, and future ventures." },
  { title: "How We Think", body: "Long-term, customer-first, data-informed, systematic, responsible, and scalable." },
  { title: "Where We Are Going", body: "Building strong independent businesses connected by one common vision." },
];

export const AboutDetail = () => (
  <section data-testid="about-detail" className="bg-midnight text-ivory py-24 lg:py-32 noise-overlay">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <div className="grid lg:grid-cols-12 gap-12 items-center mb-16">
        <Reveal className="lg:col-span-6">
          <Overline>About Us</Overline>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight">
            A multi-business organization, built to last.
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-6">
          <div className="overflow-hidden border border-white/10">
            <img src={IMAGES.team} alt="KRV Nexus corporate approach" className="w-full h-72 object-cover" />
          </div>
        </Reveal>
      </div>

      <Stagger className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
        {BLOCKS.map((b) => (
          <StaggerItem key={b.title} className="bg-midnight p-8 hover:bg-navy transition-colors">
            <h3 className="font-serif text-2xl text-gold">{b.title}</h3>
            <p className="mt-4 text-sm text-ivory/60 leading-relaxed">{b.body}</p>
          </StaggerItem>
        ))}
      </Stagger>
    </div>
  </section>
);
